import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store/index'

import Home from './pages/Home'
import ErrorPage from "./pages/ErrorPage"
import Register from './pages/Register'
import CompanyForm from './pages/CompanyForm'
import Login from './pages/Login'
import Finish from './pages/Finish'
import Plans from './pages/Plans'
import Payments from './pages/Payments'
import Products from './pages/Products'
import Pizza from './pages/Pizza'
import SpEditRestaurant from './components/SpEditRestaurant.vue'

Vue.use(VueRouter)

//define routes
const routes = [
    { path: '/erro', name: 'Error', component: ErrorPage, meta:{cleanPage:true}},
    { path: '/', name: 'Register', component: Register, meta:{cleanPage:true}},
    { path: '/produtos', name: 'AllProducts', component: Products, meta: { requiresAuth: true },
      beforeEnter: async (to, from, next)=>{
        try {
          if (store.state.token) {
            store.state.loading = true
            store.commit('SET_TYPE',null)
            store.commit('SET_SUBTYPES',{})
            await store.dispatch('fetchProducts')
            store.state.loading = false
          }
          next()
        } catch (error) {
          store.state.loading = false
          if(error === 'Token Invalido!' || error === "Gerente inexistente!"){
            store.commit("LOGOUT")
            next({name:"Login"})
          }else{
            next({name:"Error",query:{msg:"Algo inesperado aconteceu"}})
          }
        }
      }, alias: '/home'
    },
    {path: '/Estabelecimento',name:'SpEditRestaurant',component: SpEditRestaurant ,meta: { requiresAuth: true }},
    { path: '/produtos/:type/categoria', name: 'Products', component: Products, meta: { requiresAuth: true },
      beforeEnter: async (to, from, next)=>{
        try {
          if (store.state.token) {
            store.state.loading = true
            
            await store.dispatch('setMenu',to.params.type || null)
            await store.dispatch('fetchProducts')
            store.state.loading = false
          }
          next()
        } catch (error) {
          store.state.loading = false
          if(error === 'Token invalido!' || error === "Gerente inexistente!"){
            store.commit("LOGOUT")
            next({name:"Login"})
          }else{
            next({name:"Error",query:{msg:"Algo inesperado aconteceu"}})
          }
        }
      }
    },
    { path: '/pizzaria', name: 'Pizza', component: Pizza, meta: { requiresAuth: true },
      beforeEnter: async (to, from, next)=>{
        try {
          if (store.state.token) {
            store.state.loading = true
            await store.dispatch('fetchPizza')
            store.state.loading = false
          }
          next()
        } catch (error) {
          store.state.loading = false
          next({name:"Login"})
        }
      }
    },
    { path: '/entrar', name: 'Login', component: Login, meta:{ cleanPage:true }},
    { path: '/concluido', name: 'Finish', component: Finish, meta: { requiresAuth: true, cleanPage:true }},
    { path: '/dados-loja', name:'Company', component: CompanyForm, meta: { requiresAuth: true }},
    { path: '/planos', name:'Plans', component: Plans, meta: { requiresAuth: true}},
    { path: '/pagamentos/:id', name:'Payments', component: Payments, meta:{cleanPage:true}}
]


const router = new VueRouter({
  mode:'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach(async(to,from,next)=>{
  if (to.matched.some(record => record.meta.cleanPage)) {
    store.commit('IS_CLEAN_PAGE',true)
  }else{
    store.commit('IS_CLEAN_PAGE',false)
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.token) {
      next({
        name: "Login",
        query: { redirect: to.fullPath }
      })
    }
    if(!store.state.restaurant){ 
      try {
        store.state.loading = true
        await store.dispatch('fetchRestaurant')
      } catch (error) {
        if(error === 'permission denied' || error === "Gerente inexistente!"){
          store.commit("LOGOUT")
          next({
            name: "Login"
          })
        }
      } finally {
        store.state.loading = false
      }
    }
  }
  let isDelegated = false;

  for (let matched = (to.matched || []), i = matched.length; i--;) {
      let route = matched[i];

      if (route.beforeEnter) {
          isDelegated = true;
          route.beforeEnter(to, from, next);
      }
  }
  !isDelegated && next();
})

export default router